<div class="eventIcons">
  <nz-icon
    nzType="coffee"
    nzTheme="outline"
    nz-tooltip
    nzTooltipTitle="Holiday"
    *ngIf="event.IsHoliday"
  />
  <nz-icon
    nzType="redo"
    nzTheme="outline"
    nz-tooltip
    nzTooltipTitle="Recurring"
    *ngIf="event.IsRecurring"
  />
  <nz-icon
    nzType="info"
    nzTheme="outline"
    nz-tooltip
    nzTooltipTitle="Reminder"
    *ngIf="event.IsReminder"
  />
  <nz-icon
    nzType="clock-circle"
    nzTheme="outline"
    nz-tooltip
    nzTooltipTitle="Fixed arrival"
    *ngIf="event.IsFixedArrival"
  />
  <a
    *ngIf="event.hasMedia"
    nz-tooltip
    nzTooltipTitle="Attachments"
    (click)="$event.stopPropagation(); openAttachments(event)"
  >
    <nz-icon nzType="folder" nzTheme="outline" />
  </a>

  <a
    [routerLink]="['/' + InombraRoutes.Cart, event.cart]"
    [attr.middle-click]="'/' + InombraRoutes.Cart + '/' + event.cart"
    target="_blank"
    *ngIf="event.type === 'cart'"
    nz-tooltip
    nzTooltipTitle="Open project"
  >
    <nz-icon nzType="link" nzTheme="outline" />
  </a>
  <a
    [routerLink]="['/' + InombraRoutes.Workflow, event.workflow]"
    [attr.middle-click]="'/' + InombraRoutes.Workflow + '/' + event.workflow"
    target="_blank"
    *ngIf="event.type === 'workflow'"
    nz-tooltip
    nzTooltipTitle="Open project"
  >
    <nz-icon nzType="link" nzTheme="outline" />
  </a>
  <a
    [routerLink]="['/' + InombraRoutes.Account, event.account]"
    [attr.middle-click]="'/' + InombraRoutes.Account + '/' + event.account"
    target="_blank"
    *ngIf="event.type === 'account'"
    nz-tooltip
    nzTooltipTitle="Open project"
  >
    <nz-icon nzType="link" nzTheme="outline" />
  </a>
</div>
